import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import registerComponents from './components.js'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import moment from 'moment'

import VueCoreVideoPlayer from 'vue-core-video-player'
import VueToast from 'vue-toast-notification'

// Font-Awesome
import FontAwesomeIcon from 'helpers/fontawesome'
import VueFormulate from '@braid/vue-formulate'

// Self-hosted Inter (SIL Open Font License) — bundled locally, no external
// Google Fonts request. The font stack in tailwind.config.js / style.scss already
// lists "Inter" first, so these weights drive the whole UI once loaded.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'

import './assets/sass/style.scss'

Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon)

// TOOLTIP
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

Vue.use(VueToast)
Vue.use(VueCoreVideoPlayer)
Vue.use(VueFormulate, {
  library: {
    // Custom autocomplete field types (registered globally via components.js).
    icd: {
      classification: 'text',
      component: 'FormulateIcdAutocomplete',
    },
    drug: {
      classification: 'text',
      component: 'FormulateDrugAutocomplete',
    },
  },
})

// https://stackoverflow.com/questions/34308004/moment-js-with-vuejs/43113066#43113066
Vue.prototype.moment = moment
/*
 * Automically registers all
 * UI-components from   './components/ui',
 */
registerComponents(Vue)

// Rehydrate the GoTrue session before mounting so guarded routes resolve.
store.dispatch('auth/restore').finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
})
